import PATH from '@/routes/path';
import { Link } from 'react-router-dom';
import ImgWithFallback from '@/components/atoms/ImgWithFallback';
import { ipxUrl, generateSrcSet, defaultSizes } from '@/utils/ipix';

const placeholderUrl = 'https://placehold.co/600x400?text=Article';

const ArticleCard = ({ title, banner, createdAt, tags, slug }) => {
  const imageWidths = [240, 378.68];
  const ipxOptions = { quality: 75, format: 'webp' };

  const usePlaceholder = !banner || banner === placeholderUrl;

  return (
    <div className="bg-transparent p-0 shadow-none">
      <Link to={`${PATH.ARTICLE}/${slug}`}>
        <div className="relative w-full pb-[56.25%] rounded-lg overflow-hidden">
          {usePlaceholder ? (
            <img
              src={placeholderUrl}
              alt={title}
              className="absolute top-0 left-0 w-full h-full object-cover"
            />
          ) : (
            <ImgWithFallback
              src={ipxUrl(banner, { width: 378.68, ...ipxOptions })}
              srcSet={generateSrcSet(banner, imageWidths, ipxOptions)}
              fallbackSrc={banner}
              sizes={defaultSizes}
              alt={title}
              className="absolute top-0 left-0 w-full h-full object-cover cursor-pointer"
            />
          )}
        </div>
      </Link>
      <div className="p-4">
        <p className="text-gray-500 text-sm">{createdAt}</p>
        <h2 className="text-lg font-bold text-gray-900 line-clamp-2">
          <Link to={`${PATH.ARTICLE}/${slug}`}>{title}</Link>
        </h2>
        <div className="mt-2">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="text-xs font-semibold mr-2 py-1 px-2 rounded-full text-gray-800 bg-green-100"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;
